<template>
    <v-container>
      <v-card>
        <v-card-title>About</v-card-title>
        <v-card-text>Esta é a página fale conosco.</v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'IndexFaleConosco'
  }
  </script>